// Mock data for Light Chasing Adventures

export const northernLightsExperiences = [
  {
    id: 1,
    location: "Tromsø, Norway",
    title: "Arctic Aurora Adventure",
    duration: "5 nights",
    groupSize: "4-5 people",
    price: "£1,998",
    includes: ["Airport transfers from Tromsø", "Cabin lodging in Lyngen Alps", "Photography basics workshop", "Nightly aurora hunts", "Northern Lights science & observation tips"],
    description: "Arrive in Tromsø and journey to our cozy cabin in the Lyngen Alps. Experience the magic of the Northern Lights in Arctic Norway while learning to photograph the aurora and understanding the science behind this natural phenomenon.",
    image: "https://images.unsplash.com/photo-1531366936337-7c912a4589a7",
    available: true,
    bookeoProductId: null // Will show all available bookings from your Bookeo account
  },
  {
    id: 2,
    location: "Abisko, Sweden",
    title: "Blue Hole Aurora Experience",
    duration: "4 nights",
    groupSize: "4-5 people",
    price: "£2,100",
    includes: ["Airport transfers", "Mountain lodge accommodation", "Photography instruction", "Aurora observation sessions", "Light & atmosphere workshops"],
    description: "Discover one of the world's best locations for Northern Lights viewing. The famous 'Blue Hole' of Abisko offers clear skies and unforgettable aurora displays.",
    image: "https://images.unsplash.com/photo-1483347756197-71ef80e95f73",
    available: true,
    bookeoProductId: null // Add Bookeo product ID when available
  },
  {
    id: 3,
    location: "Reykjavik, Iceland",
    title: "Iceland Aurora & Ice",
    duration: "6 nights",
    groupSize: "4-5 people",
    price: "£2,500",
    includes: ["Airport transfers", "Guesthouse lodging", "Aurora photography sessions", "Ice cave exploration", "Northern Lights tracking & science"],
    description: "Combine Northern Lights photography with Iceland's dramatic winter landscapes. From ice caves to volcanic beaches under dancing auroras.",
    image: "https://images.unsplash.com/photo-1475518845976-0fd87b7e4e5d",
    available: true,
    bookeoProductId: null // Add Bookeo product ID when available
  },
  {
    id: 4,
    location: "Yukon, Canada",
    title: "Yukon Winter Lights",
    duration: "5 nights",
    groupSize: "4-5 people",
    price: "£2,450",
    includes: ["Airport transfers", "Wilderness lodge stay", "Aurora photography basics", "Night sky observation", "Northern wilderness experience"],
    description: "Experience the aurora in the vast wilderness of Canada's north. Clear, dark skies and the silence of winter create perfect conditions for photography and wonder.",
    image: "https://images.pexels.com/photos/23897319/pexels-photo-23897319.jpeg",
    available: false,
    bookeoProductId: null // Add Bookeo product ID when available
  }
];

export const seasonalAdventures = [
  {
    id: 5,
    location: "Scottish Highlands",
    title: "Highland Light & Weather",
    season: "Spring/Summer",
    duration: "3-4 days",
    groupSize: "4-6 people",
    price: "£895",
    description: "Explore dramatic Highland landscapes as the light returns. Atmospheric conditions, ancient castles, and ever-changing weather create perfect conditions for creative photography.",
    image: "https://images.unsplash.com/photo-1628946329352-4b4e9fcbfa6a",
    available: true
  },
  {
    id: 6,
    location: "Hebridean Islands",
    title: "Island Light & Seascapes",
    season: "Summer",
    duration: "4 days",
    groupSize: "4-6 people",
    price: "£950",
    description: "Journey to Scotland's remote islands where light, sea, and sky meet. Discover hidden beaches, ancient standing stones, and the unique quality of island light.",
    image: "https://images.unsplash.com/photo-1516570628389-492e1488089d",
    available: true
  },
  {
    id: 7,
    location: "Iceland (Summer)",
    title: "Midnight Sun & Waterfalls",
    season: "Summer",
    duration: "5 days",
    groupSize: "4-6 people",
    price: "£1,450",
    description: "Experience Iceland under the midnight sun. Dramatic waterfalls, black sand beaches, and endless golden hour light for photography and exploration.",
    image: "https://images.unsplash.com/photo-1562529074-e3ec282e9b60",
    available: true
  },
  {
    id: 8,
    location: "Patagonia",
    title: "Patagonian Light & Landscapes",
    season: "Dec-Feb",
    duration: "7 days",
    groupSize: "5-6 people",
    price: "£3,200",
    description: "Venture to Torres del Paine and the dramatic landscapes of southern Patagonia. Wind, weather, and wild landscapes create extraordinary photographic opportunities. For those seeking adventure beyond the usual.",
    image: "https://images.unsplash.com/photo-1569805050610-b8fab6bb14fb",
    available: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    location: "Manchester, UK",
    experience: "Tromsø Northern Lights",
    text: "I'd never used a camera in manual mode before this trip. The patient teaching and small group size meant I actually learned, rather than just taking snapshots. Seeing the aurora for the first time was incredible, but learning to capture it myself was transformative.",
    rating: 5
  },
  {
    id: 2,
    name: "James T.",
    location: "Edinburgh, UK",
    experience: "Highland Light Adventure",
    text: "This wasn't about getting 'the shot' — it was about slowing down and really seeing the landscape. I learned more about light and composition in three days than I had in months of watching YouTube tutorials. And the price was refreshingly honest.",
    rating: 5
  },
  {
    id: 3,
    name: "Emma L.",
    location: "Bristol, UK",
    experience: "Iceland Aurora",
    text: "As someone who felt intimidated by 'proper' photography tours, this was exactly what I needed. Small group, no judgment, just curiosity and learning together. The aurora was beyond words, and I have photos I'm genuinely proud of.",
    rating: 5
  }
];

// Newsletter signup storage (simulated)
export const saveNewsletterSignup = (email, name) => {
  const signups = JSON.parse(localStorage.getItem('newsletterSignups') || '[]');
  signups.push({ email, name, date: new Date().toISOString() });
  localStorage.setItem('newsletterSignups', JSON.stringify(signups));
  return true;
};